module.exports = __webpack_public_path__ + "assets/Suspicious.dba6e5b6.svg";